import axios from 'axios';

const BASE_URL_PROD = 'https://api-portal.estacioprod.net/v1/marketing/enemverso';
const API_KEY_PROD = 'Pb8ERVkg1z86WQlQFC1OL9uIcDg82i1319uxx3bL';

const BASE_URL = 'https://api-portal.estacioqa.net/v1/marketing/enemverso';
const API_KEY = 'ZCfsDct93X9V9DGbxQpo848Ifz5bxrDW5Ywr4pes';

const LOCALHOST = "http://localhost:3000/";
const AMBIENTE_QA = "https://enemverso.estacioqa.net/";

const LOCAL = document.URL !== LOCALHOST;
const QA =  document.URL !== AMBIENTE_QA;

const api = axios.create({
    baseURL: LOCAL || QA ? BASE_URL : BASE_URL_PROD,
    headers: {
        'Content-Type': 'application/json',
        'x-api-key': LOCAL || QA ? API_KEY : API_KEY_PROD
    }
});

export { api };